export default __webpack_public_path__ + "static/404error-f017281aac7736ce7abce85ac28a54a9.png";